import { useEffect } from 'react';

/**
 * 04-ux-mobile-spec.md §0 "Document scroll" — `document.documentElement` and
 * `body` get `overflow: hidden; overscroll-behavior: none` (declared on this
 * class in `waiter-root.css`) while a waiter route is mounted, killing iOS
 * rubber-band and Android pull-to-refresh on the page underneath the fixed
 * `.waiter-root` grid. `site.css`'s body is `min-height:100dvh` flex column —
 * the fixed root sits over it; this class only stops IT from scrolling.
 */
export const WAITER_DOCUMENT_LOCK_CLASS = 'waiter-doc-lock';

export function useWaiterDocumentLock(): void {
  useEffect(() => {
    document.documentElement.classList.add(WAITER_DOCUMENT_LOCK_CLASS);
    document.body.classList.add(WAITER_DOCUMENT_LOCK_CLASS);
    return () => {
      document.documentElement.classList.remove(WAITER_DOCUMENT_LOCK_CLASS);
      document.body.classList.remove(WAITER_DOCUMENT_LOCK_CLASS);
    };
  }, []);
}
